var _path, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 109,
    viewBox: "0 0 14 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.728365 10.2043L7.01057 0C7.87705 1.30267 13.0778 9.8811 13.2928 10.2043C13.9427 11.1813 14.8884 14.9012 12.2096 17.5861C9.61008 20.1914 5.71082 21.277 2.02813 17.8032C-0.832995 15.1043 -0.0659377 11.6517 0.728365 10.2043Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 30,
    x2: 7,
    y2: 108,
    stroke: "url(#paint0_linear_2528_37781)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2528_37781",
    x1: 6,
    y1: 29,
    x2: 6,
    y2: 109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain1);
export default __webpack_public_path__ + "static/media/rain1.42dfc7c6a785b89d99331088fe27bca4.svg";
export { ForwardRef as ReactComponent };